var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreviewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    d: "M19.53 5.27C17.33 2.85 13.67.28 10 .33 6.33.28 2.68 2.85.47 5.27a1.84 1.84 0 000 2.46c2.18 2.4 5.78 4.94 9.4 4.94h.25c3.62 0 7.23-2.54 9.4-4.94a1.84 1.84 0 000-2.46zM6.17 6.5a3.83 3.83 0 117.66 0 3.83 3.83 0 01-7.66 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    d: "M10 8.17a1.67 1.67 0 100-3.34 1.67 1.67 0 000 3.34z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviewIcon);
export default __webpack_public_path__ + "static/media/preview-icon.1a302ad03491ccbe9282b81029a3a806.svg";
export { ForwardRef as ReactComponent };